var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('navbar',{attrs:{"id":"navbar"}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('router-view')],1)])]),_c('pie')],1)}
var staticRenderFns = []

export { render, staticRenderFns }